import './style.scss';

function DateRangeFilter({
  dateFrom = '',
  dateTo = '',
  onChange,
  onClear,
  disabled = false,
  className = ''
}) {
  const hasFilters = Boolean(dateFrom || dateTo);
  const rootClassName = className
    ? `date-range-filter ${className}`
    : 'date-range-filter';

  return (
    <div className={rootClassName}>
      <label className='date-range-filter__field'>
        <span>Desde</span>
        <input
          type='date'
          value={dateFrom}
          max={dateTo || undefined}
          disabled={disabled}
          onChange={({ target }) => onChange?.('dateFrom', target.value)}
        />
      </label>

      <label className='date-range-filter__field'>
        <span>Hasta</span>
        <input
          type='date'
          value={dateTo}
          min={dateFrom || undefined}
          disabled={disabled}
          onChange={({ target }) => onChange?.('dateTo', target.value)}
        />
      </label>

      {hasFilters ? (
        <button
          type='button'
          className='date-range-filter__clear'
          onClick={onClear}
          disabled={disabled}>
          <span className='material-symbols-rounded' aria-hidden='true'>
            close
          </span>
          <span>Limpiar</span>
        </button>
      ) : null}
    </div>
  );
}

export default DateRangeFilter;
